import { type FC, type PropsWithChildren, useState } from 'react';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { isValueVoucherWithPriceRange } from '../../shared/product-safeguards';
import { PriceContext } from '../contexts';
import { type ProductDetailContext } from '../types/types';

const PriceProvider: FC<PropsWithChildren> = ({ children }) => {
    const { price: defaultPrice, product } = useFragmentContext<ProductDetailContext>();
    const [multiplier, setMultiplier] = useState<number>(1);
    const [amount, setAmount] = useState<number>(
        isValueVoucherWithPriceRange(product)
            ? product.priceRange.min.amount
            : defaultPrice.gross.amount,
    );

    return (
        <PriceContext
            value={{
                price: {
                    ...defaultPrice,
                    multiplier,
                    gross: {
                        ...defaultPrice.gross,
                        amount: amount * multiplier,
                    },
                },
                setAmount,
                setMultiplier,
            }}
        >
            {children}
        </PriceContext>
    );
};

export { PriceProvider };
